import { MediaManagerSDKFile } from '../media-manager-sdk';
import { TMMGRSettings } from '../hoc/withMMGRSettings/withMMGRSettings.types';
import { isMediaFromWix } from '../media-manager-sdk/sources';
import { MediaType } from '../../constants/MediaType';

export const buyItem = (
  item: MediaManagerSDKFile,
  mmgrSettings: TMMGRSettings,
): Promise<{ item: MediaManagerSDKFile; isNew: boolean }> =>
  new Promise((resolve, reject) => {
    const mediaFromWixUrl = `https://pix.wix.com/services/wixstock/start_purchase?site_token=${mmgrSettings.siteMediaToken}&image_id=${item.id}`;

    const pictureShutterstockUrl = `${mmgrSettings.shutterStockPaymentAPI}/services/shutterstock/start_purchase?site_token=${mmgrSettings.siteMediaToken}&image_id=${item.id}&altsku=1`;

    const videoShutterstockUrl = `${mmgrSettings.shutterStockPaymentAPI}/services/shutterstock/video/start_purchase?site_token=${mmgrSettings.siteMediaToken}&video_id=${item.id}&altsku=1`;

    const url = isMediaFromWix(item.source)
      ? mediaFromWixUrl
      : item.mediaType === MediaType.Picture
      ? pictureShutterstockUrl
      : videoShutterstockUrl;

    window.open(url, '_blank', 'width=1000,height=550,scrollbars=1');

    const onWindowMessage = (event) => {
      if (/premium\./i.test(event.origin)) {
        const response = JSON.parse(event.data);
        const [itemId] = response.packageUniqueId.split('_');
        if (itemId === item.id) {
          window.removeEventListener('message', onWindowMessage, false);
          if (response.success) {
            resolve({ item, isNew: true });
          } else {
            reject({ item });
          }
        }
      }
    };

    window.addEventListener('message', onWindowMessage, false);

    window.focus();
  });
